
/**
 * 
 * @param {number} productsByPage Number of products to display per page
 * @param {array} products Liste of products
 * @param {number} page current page
 * @returns Array - [Liste products in the current page, total number of pages]
 */
export const pagination = (productsByPage = 16, products, page = 1) => {

  if (!products) return products
  // Nombre de page
  let numberOfPage = 0;
  if (products) {
    numberOfPage = Math.ceil(products.length / productsByPage);
  }

  // Produits a afficher sur chaque pages:
  const productsDisplayed = page * productsByPage;
  // Nombre de page au total
  const slicedProducts = products.slice(
    productsDisplayed - productsByPage,
    productsDisplayed
  );

  return [slicedProducts, numberOfPage]
};
